// about vuex
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import loading from '../../../share/components/vue/ProcessingIcon';
import vehicle from '../../../share/util/vehicle';

export default {
  data() {
    return {
      processing: false,
      usbVerificationInfo: [],
      fieldsConfig: [],
    };
  },

  components: {
    'processing-view': loading
  },

  watch: {
    language(val) { // eslint-disable-line no-unused-vars
      // カラムヘッダ再設定
      this.setSystemConfig();
      // システム名を再設定
      const names = vehicle.getTargetUnitDisplayNames(this.resources, this.language);
      const name = names[this.ccuReproInfo.systemId];
      this.usbVerificationInfo = [];
      this.usbVerificationInfo.push({
        targetSystem: name || this.$t('message.common_hyphen'),
        newSwid: this.ccuReproInfo.newSwid || this.$t('message.common_hyphen'),
        usbSwid: this.ccuReproInfo.usbSwid || this.$t('message.common_hyphen')
      });
    }
  },

  computed: {
    ...mapState({
      vehicleInfo: state => state.vehicle.vehicleInfo,
      ccuReproInfo: state => state.cache.ccuReproInfo,
      language: state => state.systems.language,
      resources: state => state.masterResources.targetUnits,
      isTestMode: state => state.netAppConnector.isTestMode
    }),
  },

  methods: {
    ...mapActions('cache', ['cacheDisplayMode']),

    // HOME画面に戻る
    backToHome: function () {
      // Vehicle 画面の初期表示は公開一覧
      this.cacheDisplayMode(true);
      // システム画面へ遷移
      if (this.vehicleInfo.vehicle.is_su_flow) {
        this.$router.push({ name: 'suSystemTable' });
      } else {
        this.$router.push({ name: 'systemTable' });
      }
    },

    // USB照合失敗のテーブルカラムを生成
    setSystemConfig: function () {
      this.fieldsConfig = [
        { key: 'targetSystem', label: this.$t('message.header_usb_verification_target_system') },
        { key: 'newSwid', label: this.$t('message.header_usb_verification_new_swid') },
        { key: 'usbSwid', label: this.$t('message.header_usb_verification_usb_swid') }
      ];
    },
  },

  async created() {
    this.setSystemConfig();
    this.usbVerificationInfo.push({
      targetSystem: this.ccuReproInfo.systemName || this.$t('message.common_hyphen'),
      newSwid: this.ccuReproInfo.newSwid || this.$t('message.common_hyphen'),
      usbSwid: this.ccuReproInfo.usbSwid || this.$t('message.common_hyphen')
    });
  },

  mounted() {
  },

  beforeUnmount() {
  },
};